export default {"src":"/_next/static/media/info-icon.bac5163c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};